import React from 'react';
import { Link } from 'react-router-dom';
import './CTAButton.scss';

interface Props {
  text: string;
  to?: string;
  disabled?: boolean;
  fill?: true;
  invert?: boolean;
  iconSrc?: string;
  className?: string;
  type?: 'button' | 'submit';
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export const CTAButton = React.memo<Props>(
  ({ type, text, to, disabled, fill, invert, iconSrc, className, onClick }) => {
    if (to) {
      return (
        <Link
          onClick={onClick}
          className={`cta-button ${fill ? 'mod-fill' : ''} ${invert ? 'mod-invert' : ''}`}
          to={to}
        >
          {text}
        </Link>
      );
    }
    return (
      <button
        disabled={disabled}
        type={type === 'submit' ? 'submit' : 'button'}
        onClick={onClick}
        className={`cta-button ${fill ? 'mod-fill' : ''}  ${invert ? 'mod-invert' : ''} ${className || ''} ${
          disabled ? 'mod-disabled' : ''
        }`}
      >
        <span>{text}</span>
        {iconSrc && <img alt="" src={iconSrc} />}
      </button>
    );
  },
);

CTAButton.displayName = 'CTAButton';

export default CTAButton;
